import { Table, Tag, Image } from "antd";
import BSCIcon from "../assets/icons/bsc.svg";
import { configs } from "../configs/config";

function NFTMintedTxList(props) {
  const style = {
    table: {
      marginTop:'10px',
      color: '#FFFFFF',
      background: '#050021',
    }
  }
  const {transactionList } = props;
  const columns = [
    {
      title:"Block #",
      dataIndex:"block",
      key: 'block',
      align:'center',
      ellipsis: true,
      render: block => (<Tag color='volcano' key={block}>{block}</Tag>)
    },
    {
      title:"Transaction Hash",
      dataIndex:"transactionHash",
      key: 'transactionHash',
      ellipsis: true,
    },
    {
      title:"Minted By",
      dataIndex:"mintedBy",
      key: 'mintedBy',
      align:'center',
      ellipsis: true,
    },
    {
      title:"View Tnx",
      key: 'action',
      align:'center',
      render: data => (
      <div> 
        <a href={ configs.nftContractConfig.blockchainNetwork + 'tx/' + data.transactionHash }  target='_blank' rel="noreferrer">
          <Image preview={false} width={20} height={20} src={BSCIcon}/>
        </a>
      </div>
      )
    }
  ]
  return (
   <div>
     <div className="ntf-tx-title">Recently minted NFT transactions</div>
     <div className="transaction-table" style={style.table}>
        <Table columns={columns} dataSource={transactionList} size="small" pagination={{ position: ['none', 'none'] }}/>
     </div>
   </div>
  );
}
export default NFTMintedTxList;
